import React, { useMemo } from 'react'

import { usePrismicPreviewStoreState } from '../hooks/usePrismicPreviewStore'

import { InvalidPreview } from '../components/InvalidPreview'
import { ErrorBoundary } from '../components/ErrorBoundary'

export const BaseUnpublishedPreviewTemplate = ({
  location,
  templateMap = {},
  ...props
}) => {
  const { getPreviewDataForPath } = usePrismicPreviewStoreState()
  const previewData = getPreviewDataForPath(location.pathname)

  const Comp = useMemo(() => {
    if (!previewData) return undefined

    // This is hacky. But we know the preview data will only have one key.
    const docKey = Object.keys(previewData)[0]
    const doc = previewData[docKey]

    return templateMap[doc?.type]?.({ doc })
  }, [previewData, templateMap])

  return previewData && Comp ? (
    <Comp location={location} data={previewData} {...props} />
  ) : (
    <InvalidPreview>
      Oh no! Looks like something went wrong with this preview. Please try
      again.
    </InvalidPreview>
  )
}

export const UnpublishedPreviewTemplate = props => (
  <ErrorBoundary
    fallback={
      <InvalidPreview>
        Oh no! Looks like something went wrong with this preview. Please try
        again.
      </InvalidPreview>
    }
  >
    <BaseUnpublishedPreviewTemplate {...props} />
  </ErrorBoundary>
)
